import { useEffect, useState, useRef } from 'react';
import { useThrottleFn } from 'ahooks';

// 滚动距离阈值，超过该值则处理head透明交互效果
const scrollTopThreshold = 50;

export default ({ watchImg = false }: { watchImg?: boolean }) => {
  const [opacity, setOpacity] = useState(0);
  const disabledScroll = useRef(false);
  const { run: handleScroll } = useThrottleFn(() => {
    if (disabledScroll.current) return;
    const scrollTop = document.documentElement.scrollTop;
    let scrollOpacity = 0;
    if (scrollTop > scrollTopThreshold) {
      scrollOpacity = 1;
    } else {
      scrollOpacity = (scrollTop / scrollTopThreshold) * 0.8;
    }
    setOpacity(scrollOpacity);
  }, { wait: 100 });

  const init = () => {
    disabledScroll.current = document.documentElement.scrollHeight - document.documentElement.clientHeight < scrollTopThreshold;
  }

  useEffect(() => {
    if (watchImg) {
      const imgList = [...document.querySelectorAll('img.watch-img')];
      let imgCount = imgList.length;
      imgList.forEach((img: any) => {
        img.onload = () => {
          imgCount--;
          if (imgCount === 0) {
            init()
          }
        };
      });
    } else {
      setTimeout(init, 300);
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return {
    opacity
  };
};